import React from "react";
import { useQuickSightIAM } from "@/hooks/useIAMReports";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightAwsIAMDashboard from "@/components/organisms/IAMDashboard";

function IAMReports() {
  const { embedUrl, loading, error, refetch } = useQuickSightIAM();

  return (
    <AWSReportsTemplate
      title="AWS IAM Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightAwsIAMDashboard />
    </AWSReportsTemplate>
  );
}

export default IAMReports;
